<div class="npdc-title">
  <h1>Cases</h1>
  <div class="npdc-title__actions">
    @if (authService.canInvoke(authService.endpoints.createCase)) {
      <a mat-flat-button routerLink="new">New case</a>
    }
  </div>
</div>

<p>
  Searchable listing of placename proposals (cases) handled by the Norwegian Polar Institute's
  <a href="https://npolar.no/en/maps/polar-place-names/"> naming committee</a>. Cases contain
  information about the area, proposed name, person(s) that submitted the proposal and final
  conclusions. They give an insight in the naming process. Entries are made in Norwegian, the
  working language of the naming committee.
</p>

<div class="npdc-search">
  <div class="npdc-search__input">
    <div class="npdc-search__input__prefix">
      <mat-icon>search</mat-icon>
    </div>
    <input
      type="search"
      placeholder="Search in cases..."
      [value]="q()"
      (keydown.enter)="onSearchEvent($event)"
    />
  </div>
</div>

<app-list [resource]="cases" [disableClear]="!q()">
  @if (!cases.error()) {
    <mat-nav-list>
      @for (c of cases.value()?.items; track c.id) {
        <a mat-list-item routerLink="{{ c.id }}">
          <mat-icon matListItemIcon>folder_open</mat-icon>

          <span matListItemTitle>{{ c.title }}</span>
          <span matListItemLine>{{ c.area || 'N/A' }}, {{ c.date | date: 'yyyy' }}</span>
          <span matListItemLine>Case {{ c.number || 'N/A' }}</span>
        </a>
      }
    </mat-nav-list>

    <mat-paginator
      showFirstLastButtons
      (page)="onPageEvent($event)"
      [length]="count()"
      [pageIndex]="page()"
      [pageSize]="pageSize()"
      [pageSizeOptions]="[10, 20, 50, 100]"
    >
    </mat-paginator>
  }
</app-list>
